import { validateCompletion } from '../../../../backend/config/classifiers/AccountSectionClassifier/shared';
import { useContactManagementTranslation } from '../../../../ui/hooks/useContactManagementTranslation';
import { ContactManagementConfigContext } from '../../../../ui/providers';
import { CircleBar } from '@juvare/common-web-ui/CircleBar';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Chip, Typography } from '@mui/material';
import { green } from '@mui/material/colors';
import React from 'react';
import { useAccountSections } from '../hooks/useAccountSections';
export const AccountCompletionBar = (props) => {
    const { title, account } = props;
    const { t } = useContactManagementTranslation();
    const sections = useAccountSections('details');
    const { accountConfig } = React.useContext(ContactManagementConfigContext);
    const validationResult = React.useMemo(() => { var _a; return validateCompletion((_a = sections.data) !== null && _a !== void 0 ? _a : [], accountConfig, account.data); }, [accountConfig, account.data, sections.data]);
    const value = validationResult && validationResult.totalFieldCount > 0
        ? validationResult.totalFieldCount > 0
            ? validationResult.completedFieldCount / validationResult.totalFieldCount
            : 1
        : 0;
    return (React.createElement(Box, { sx: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
        } },
        React.createElement(CircleBar, { size: 70, strokeWidth: 5, offset: 0.79, value: value, color: value === 1 ? green[500] : themeColors.primary.base, showPercent: true, "data-test": 'account-completion-bar' }),
        React.createElement(Typography, { sx: {
                mt: 1,
            }, variant: 'body2' }, title),
        validationResult.incompleteSections.length > 0 && (React.createElement(Chip, { sx: {
                borderRadius: '24px',
                height: 'auto',
                mt: 0.5,
                px: 1,
                py: 0.5,
                textAlign: 'center',
                '& .MuiChip-label': {
                    whiteSpace: 'break-spaces',
                },
                backgroundColor: themeColors.accent.red.bold,
                color: 'white',
            }, size: 'small', label: t('panels.accounts.sectionNeedsAttention', { count: validationResult.incompleteSections.length }) }))));
};
